<template>
  <b-container fluid>
    <b-row id="header-container" class="justify-content-center">
      <b-col md="10">
        <b-row align-h="between">
          <b-col md="6">
            <img alt="gravity logo" src="../../assets/logo.png" />
          </b-col>
          <b-col md="6" xs="3" class="started-button d-none d-sm-block">
            <a
              href="https://www.getrocketsignals.com/demo"
            >
              <b-button class="button-white-transparent">Request Demo</b-button>
            </a>
          </b-col>
        </b-row>
        <b-row align-h="start" class="text-content">
          <b-col>
            <h1 class="text-white title text-left">Start Conversations with <br/>Actionable Insights.<!--We Help Build Your Traction--></h1>
          </b-col>
        </b-row>
        <b-row align-h="start">
          <b-col class="mt-2">
            <h4 class="text-white text-left" md="6">
              <b>For sales, marketing, customer success & investors <!-- Start personalized conversations with expert timing --></b>
            </h4>
            <!--
            <h2 class="text-white sub-title text-left">
              With Fresh Leads
            </h2>
            <h2 class="text-white sub-title text-left">
              & a Fleet of Data-Driven
            </h2>
            <h2 class="text-white sub-title text-left">
              Marketing & Sales tools
            </h2>
            -->
          </b-col>
        </b-row>
        <!--
        <b-row align-h="start">
          <b-col class="mt-1 second-sub-title-container">
            <h3 class="text-white second-sub-title text-left">
              A fleet of data-driven marketing & sales tools
            </h3>
            <h3 class="text-white second-sub-title text-left">
              A fleet of data-driven marketing & sales tools
            </h3>
            <h3 class="text-white second-sub-title text-left">
              A fleet of marketing and sales tools fueled with fresh B2B leads.
            </h3>
          </b-col>
        </b-row>
        -->
        <b-row align-h="start">
          <b-col
            cols="12"
            md="6"
            class="d-flex mt-5 justify-content-center justify-content-md-start"
          >
            <a href="https://www.getrocketsignals.com/demo">
              <b-button class="button-white-transparent">
                Request Demo
              </b-button>
            </a>
            <!--<b><p style="color:white; padding: 11px;">or <a href="https://calendly.com/rosse/gravity-demo" target="_blank" style="color:white;">book a demo</a></p></b>-->
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row id="header-section-two" class="justify-content-center">
      <b-col
        cols="10"
        class="d-flex justify-content-center flex-column trusted-container"
      >
        <b-row class="justify-content-center">
          <b-col cols="12" class="d-flex justify-content-center">
            <p style="padding-top:60px;" class="text-white trusted-by-title text-center">
              We power conversations at leading companies
            </p>
          </b-col>
        </b-row>
        <b-row class="justify-content-center trusted-brands-container">
          <b-col
            cols="6"
            md="3"
            class="d-flex align-items-center justify-content-center image-container"
          >
            <img
              class="image"
              alt="trusted logo"
              src="../../assets/t-logo-1.png"
            />
          </b-col>
          <b-col
            cols="6"
            md="3"
            class="d-flex align-items-center justify-content-center image-container"
          >
            <img
              class="image"
              alt="trusted logo"
              src="../../assets/t-logo-2.png"
            />
          </b-col>
          <b-col
            cols="6"
            md="3"
            class="d-flex align-items-center justify-content-center image-container"
          >
            <img
              class="image"
              alt="trusted logo"
              src="../../assets/t-logo-3.png"
            />
          </b-col>
          <b-col
            cols="6"
            md="3"
            class="d-flex align-items-center justify-content-center image-container"
          >
            <img
              class="image"
              alt="trusted logo"
              src="../../assets/t-logo-4.png"
            />
          </b-col>
        </b-row>
        <b-row class="justify-content-center trusted-brands-container">
          <b-col
            cols="6"
            md="3"
            class="d-flex align-items-center justify-content-center image-container"
          >
            <img
              class="image"
              alt="trusted logo"
              src="../../assets/t-logo-5.png"
            />
          </b-col>
          <b-col
            cols="6"
            md="3"
            class="d-flex align-items-center justify-content-center image-container"
          >
            <img
              class="image"
              alt="trusted logo"
              src="../../assets/t-logo-6.png"
            />
          </b-col>
          <b-col
            cols="6"
            md="3"
            class="d-flex align-items-center justify-content-center image-container"
          >
            <img
              class="image"
              alt="trusted logo"
              src="../../assets/t-logo-7.png"
            />
          </b-col>
          <b-col
            cols="6"
            md="3"
            class="d-flex align-items-center justify-content-center image-container"
          >
            <img
              class="image"
              alt="trusted logo"
              src="../../assets/t-logo-8.png"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped lang="sass">
@import @/sass/screens/home/header.sass
</style>

<script>
export default {
  name: 'Header',
}
</script>
